import { inject, observer, Provider } from 'mobx-react';
import React from 'react';
import { NavigateFunction } from 'react-router-dom';
import { Button, Dropdown, Grid } from 'semantic-ui-react';
import withNavigation from '../../hocs/withNavigation';
import { AgGridReact } from '@ag-grid-community/react/lib/agGridReact';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-theme-alpine.css';
import { AgGridText } from '../../core/agGridText';
import OpenItem from "../../components/OpenItem";
import { GridApi, GridReadyEvent } from '@ag-grid-enterprise/all-modules';
import { RootStore } from '../../stores/RootStore';
import { CalibraStore } from './CalibraStore';
import { NumberListModel } from '../../models/numberListModel';

interface IStores {
	CalibraStore: CalibraStore;
}

interface ICalibraPageProps {
	navigate?: NavigateFunction;
	RootStore?: RootStore;
}

class CalibraPage extends React.Component<ICalibraPageProps> {
	private stores: IStores;
	gridApi: GridApi;

	constructor(props: any) {
		super(props);

		this.stores = { CalibraStore: new CalibraStore(this.props.navigate, this.props.RootStore) };

	}

	handleGridReady(event: GridReadyEvent) {
		event.api.sizeColumnsToFit();
		this.gridApi = event.api;		
	}

	componentDidMount(): void {		
		// let storeCookie=	this.stores.CalibraStore.readCookie('SelectedStore')

		// if(storeCookie){
		// 	this.stores.CalibraStore.selectedStoreCodeTask = storeCookie;
		// 	this.stores.CalibraStore.selectedStoreCodeOffer = storeCookie;
		// }else{
		// 	this.stores.CalibraStore.selectedStoreCodeTask = 'all';
		// 	this.stores.CalibraStore.selectedStoreCodeOffer = 'all';
		// }        
		this.props.RootStore.selectSelection(2)
		this.stores.CalibraStore.getAllCalibras();
	}

	deselectAll() {
		this.gridApi.deselectAll();
	}

	getCalibrationDocumentsInZip() {
		this.stores.CalibraStore.getCalibrationDocumentsInZip();
		this.deselectAll();
	}	

	exportCalibras() {							
		this.stores.CalibraStore.exportCalibras();
	}

	public render() {
		return (
			<div>
				<Provider {...this.stores}>
					<div>
						<Grid style={{ paddingTop: 30 }}>
							<Grid.Row centered>
								<Grid.Column width={12}>	
								<Grid.Row>									
									<React.Fragment>
										<Button color="orange" disabled={!this.stores.CalibraStore.getAnyRowSelected} onClick={() => { this.deselectAll() }}>Kijelölés(ek) visszavonása</Button>
										<Button color="green" disabled={!this.stores.CalibraStore.getAnyRowSelected} onClick={() => { this.getCalibrationDocumentsInZip() }} style={{marginLeft: 5}}>Letöltés</Button>
										{(this.stores.CalibraStore.RootStore.currentUser.IsHQCalibrator || this.stores.CalibraStore.RootStore.currentUser.HoldingAdmin || this.stores.CalibraStore.RootStore.currentUser.HoldingGlobalViewer ) 
										&& <Button color="green" onClick={() => { this.exportCalibras() }} style={{marginLeft: 'auto'}}>Adatok exportálása</Button>}								
									</React.Fragment>
								</Grid.Row>																																
									<div id="grid" className="ag-theme-alpine" style={{ width: '1400px', height: '519px', marginTop: 5 }}>
										<AgGridReact
											rowData={this.stores.CalibraStore.calibrasList}
											columnDefs={this.stores.CalibraStore.columnDef}
											localeText={AgGridText}
											pagination={true}
											frameworkComponents={{ btnCellRenderer: OpenItem }}
											paginationPageSize={10}
											onGridReady={(event: any) => this.handleGridReady(event)}
											gridOptions={{
												paginationNumberFormatter: (params: any) => {
													return params.value.toLocaleString();
												},						
												rowSelection: 'multiple',
												rowMultiSelectWithClick: true,
												onSelectionChanged: (event: any) => this.stores.CalibraStore.setSelectedRow(event)						
											}}
											getRowStyle={(params: any) => {
												if (params.data?.IsDeleted) {
												  return { backgroundColor: '#ff4e4e' };
												}
												return {};
											  }}
										>
										</AgGridReact>
									</div>
								</Grid.Column>
							</Grid.Row>							
						</Grid>
					</div>
				</Provider>
			</div>
		);
	}
}

export default withNavigation(inject('RootStore')(observer(CalibraPage)));